import {inject, injectable} from 'inversify';

import type {BNUserFormsAnswersReadParams} from '../../../../../../api/types/bnrks/methods';
import type {BNBoundFormApiModel} from '../../../../../../api/types/bnrks/models';
import type {FetchCromByIdQuery} from '../FetchCromById.query';

import {apiRequest} from '../../../../../../api/utils/apiRequest';
import {expandObj} from '../../../../../../api/utils/expand';
import {CromMapperJrpc} from '../../../domain/Crom/mappers/jrpc/Crom.mapper.jrpc';

@injectable()
export class FetchCromByIdQueryJrpc implements FetchCromByIdQuery {
  constructor(
    @inject(CromMapperJrpc)
    private readonly cromMapper: CromMapperJrpc,
  ) {}

  async fetchById(cromId: string): FetchCromByIdQuery.Response {
    const {
      _expanded,
      bound_form,
    }: {_expanded: Record<string, any>; bound_form: BNBoundFormApiModel} =
      await apiRequest<BNUserFormsAnswersReadParams>({
        method: 'user.forms.answers.read',
        params: {
          _id: cromId,
          expand: this.cromMapper.expand.getByEnv(),
        },
      });

    const expandedForm: CromMapperJrpc.ExpandedApiData = expandObj(bound_form, {
      expand: this.cromMapper.expand.getByEnv(),
      expanded: _expanded,
    });

    return this.cromMapper.mapDataToModel(expandedForm);
  }
}
